import { render, staticRenderFns } from "./windHazardReview.component.vue?vue&type=template&id=b7c4d5ae&scoped=true&"
import script from "./windHazardReview.component.vue?vue&type=script&lang=js&"
export * from "./windHazardReview.component.vue?vue&type=script&lang=js&"
import style0 from "./windHazardReview.component.vue?vue&type=style&index=0&id=b7c4d5ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c4d5ae",
  null
  
)

export default component.exports